import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SegmentCreator from "Admissions/features/CRM/components/Segments/components/SegmentCreator";

export default store => ({
  path: "segments",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-crm" */ "Admissions/features/CRM/components/Segments"
    ).then(m => m.default)
  ),
  childRoutes: [SegmentCreator(store)],
});
